import React from 'react';
import { Wrapper, Text, Value } from './styled';

const Option = ({ value, text, description }) => {
    return (
        <Wrapper>
            <Value>{value}&nbsp;<span>{text}</span></Value>
            <Text>{description}</Text>
        </Wrapper>
    );
};

export default Option;
